export const CV =
  "https://drive.google.com/file/d/1P04LGyrmntCWNbTQmEj9FGOGb9CmSQvB/view?usp=sharing";
